import { Box, Button, Center, Heading, Text } from '@chakra-ui/react';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';
import { Emoji } from '@/imports/ui/chakra/components/Emoji';

import { useCreateUpgradeRequest } from './useCreateUpgradeRequest';

export const FullWidthCard: React.FC<{
  organizationId: string;
  headerText: string;
  bodyText: string;
  shouldShowUpgradeCTA: boolean;
  source: string;
  height?: string;
  hideCTAButtons?: boolean;
}> = ({
  organizationId,
  headerText,
  bodyText,
  shouldShowUpgradeCTA = true,
  source,
  height = 'xl',
  hideCTAButtons = false,
}) => {
  const { requestOrganizationUpgrade, loading, submittedUpgrade } =
    useCreateUpgradeRequest(organizationId);

  const handleClick = async (buttonText: string): Promise<void> => {
    await requestOrganizationUpgrade(`${source}: "${buttonText}" button`);
  };

  return (
    <Card
      w="full"
      height={height}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      p="8"
    >
      <Box textAlign="center">
        <Emoji
          label={submittedUpgrade ? 'check mark' : 'old key'}
          symbol={submittedUpgrade ? '✅' : '🗝️'}
          fontSize="4xl"
          lineHeight="normal"
        />

        <Heading as="h4" size="md" mt="5">
          {submittedUpgrade ? 'We’ll Be in Touch Soon!' : headerText}
        </Heading>

        <Text color="gray.500" mt="2" mb="6">
          {submittedUpgrade
            ? `Our team has been notified of your interest and someone will be in touch with you soon!`
            : bodyText}
        </Text>
      </Box>

      {!hideCTAButtons && !submittedUpgrade && shouldShowUpgradeCTA && (
        <Center>
          <Button
            colorScheme="gray"
            variant="outline"
            mr="4"
            isLoading={loading}
            onClick={() => handleClick('Contact us to learn more')}
          >
            Contact Us to Learn More
          </Button>

          <Button
            isLoading={loading}
            onClick={() => handleClick('Upgrade now')}
          >
            Upgrade Now
          </Button>
        </Center>
      )}
    </Card>
  );
};
